import { createUseStyles } from 'react-jss'

const useInventoryColumnsStyles = createUseStyles({
  columnsWrapper: {
    display: 'flex',
    gap: 25
  },
  allocationColumn: {
    width: 74,
    textAlign: 'center'
  },
  remainingColumn: {
    width: 74,
    textAlign: 'center'
  }
})

export default useInventoryColumnsStyles
